// eslint-disable-next-line import/prefer-default-export
export const RELOAD_TIMEOUT = 10 * 60 * 1000; // 10 min
